import { QuizDefault } from 'icons';
import { useTranslation } from 'react-i18next';

import { Quiz } from '@cfa/pathway-fe-shared/xp';
import { Button } from '@cfa/react-components';

import { itemByLanguage } from '@/utils/language';

import { PathwayCard } from '@/components/pathway-card';

import { mapCategoryToColor } from 'utils/categoryUtils';

interface QuizLibraryCardProps {
  onAddQuiz: (quiz: Quiz) => void;
  onPreviewQuiz: (quiz: Quiz) => void;
  quiz: Quiz;
  quizAddButtonTestId: string;
  quizNameTestId: string;
}

const QuizLibraryCard: React.FC<QuizLibraryCardProps> = ({
  onAddQuiz,
  onPreviewQuiz,
  quiz,
  quizAddButtonTestId,
  quizNameTestId,
}) => {
  const { t } = useTranslation();
  const quizName = itemByLanguage(quiz.name);

  return (
    <PathwayCard.Root
      className="quizCard my-2 animate-[fadeIn_linear_0.3s] p-0!"
      noHover
    >
      <PathwayCard.Media
        className="items-center px-4 py-6"
        style={{ backgroundColor: mapCategoryToColor('default') }}
      >
        <QuizDefault />
      </PathwayCard.Media>
      <PathwayCard.Body className="p-4">
        <PathwayCard.Title
          data-testid={quizNameTestId}
          className="font-normal!"
        >
          {quizName}
        </PathwayCard.Title>
      </PathwayCard.Body>
      <PathwayCard.Actions className="ml-0 gap-4 py-4 pr-4">
        <Button
          className="min-w-[unset]!"
          color="secondary"
          data-testid="quizPreviewButtonTest"
          onClick={() => onPreviewQuiz(quiz)}
          variant="outlined"
        >
          {t('Button.preview')}
        </Button>
        <Button
          className="min-w-[unset]!"
          color="secondary"
          data-testid={quizAddButtonTestId}
          onClick={() => onAddQuiz(quiz)}
          variant="filled"
        >
          {t('Button.add')}
        </Button>
      </PathwayCard.Actions>
    </PathwayCard.Root>
  );
};

export default QuizLibraryCard;
